import graphqlClient from '@/graphql/graphql-client';
import { eqFromWhere, toListQueryVariables, toPagingOnlyVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  TemplatePagessBySlugAndLocaleDocument,
  TemplatePagessDocument,
  type TemplatePagessQuery,
} from '@/graphql/generated/graphql';

export type TemplatePageItem = NonNullable<
  NonNullable<TemplatePagessQuery['getTemplatePagess']>['items']
>[number];
export type GetTemplatePagesResponse = TemplatePagessQuery;

export const toTemplatePagesRequest = (
  params?: ListQueryVariables<Record<string, unknown>> | null
) => {
  const { where, paging } = toListQueryVariables(params);
  const slug = eqFromWhere(where, 'Slug');
  const locale = eqFromWhere(where, 'Locale');
  if (slug && locale) {
    return {
      document: TemplatePagessBySlugAndLocaleDocument,
      variables: { slug, locale, pageNo: paging.pageNo, pageSize: paging.pageSize },
    };
  }
  return {
    document: TemplatePagessDocument,
    variables: toPagingOnlyVariables(params),
  };
};

export const useGetTemplatePages = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const request = toTemplatePagesRequest(params);
  return useQuery({
    queryKey: ['template-pages', request.variables],
    queryFn: () => graphqlClient.request(request.document, request.variables),
  });
};

export const requestTemplatePages = (
  params?: ListQueryVariables<Record<string, unknown>> | null
) => {
  const request = toTemplatePagesRequest(params);
  return graphqlClient.request(request.document, request.variables);
};

export const GET_TEMPLATE_PAGES_QUERY = TemplatePagessDocument;
export const GET_TEMPLATE_PAGES_BY_SLUG_QUERY = TemplatePagessBySlugAndLocaleDocument;
